const getCreditCardType = (value) => {
  let testVal;

  if (!value) {
    return null;
  }
  const cleanValue = value.replace(/ /g, '');
  if (!cleanValue) {
    return null;
  }
  /*
  // DINERS_CLUB
  testVal = Number(cleanValue.substr(0, 2));
  if (testVal === 36 || testVal === 38 || testVal === 39 || testVal === 54 || testVal === 55) {
    return 'dc';
  }
  testVal = Number(cleanValue.substr(0, 3));
  if (testVal === 309 || (testVal >= 300 && testVal <= 305)) {
    return 'dc';
  }

  // JCB
  testVal = Number(cleanValue.substr(0, 4));
  if (testVal >= 3528 && testVal <= 3589) {
    return 'jcb';
  }
*/
  // AMERICAN_EXPRESS
  testVal = Number(cleanValue.substr(0, 2));
  if (testVal === 34 || testVal === 37) {
    return 'amex';
  }

  // VISA
  testVal = Number(cleanValue.substr(0, 1));
  if (testVal === 4) {
    return 'visa';
  }

  // MASTERCARD
  testVal = Number(cleanValue.substr(0, 2));
  if (testVal >= 50 && testVal <= 55) {
    return 'mc';
  }

  // DISCOVER
  testVal = Number(cleanValue.substr(0, 2));
  if (testVal === 65) {
    return 'disc';
  }
  testVal = Number(cleanValue.substr(0, 3));
  if (testVal >= 644 && testVal <= 649) {
    return 'disc';
  }
  testVal = Number(cleanValue.substr(0, 4));
  if (testVal === 6011) {
    return 'disc';
  }
  testVal = Number(cleanValue.substr(0, 6));
  if (testVal >= 622126 && testVal <= 622925) {
    return 'disc';
  }
  return null;
};

export default getCreditCardType;
